import { useContext, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { UserContext } from "../../../../context";
import { getIncidencias } from "./handlers";
import { MuniSpinner2, Table } from "../../../../components";
import { tableData } from "./tableData";
import FormAgregarIncidencia from "./FormAgregarIncidencia";
import { Button } from "react-bootstrap";

const Incidencias = (props) => {
  const { camara_id, incidencias, setIncidencias } = props;
  const { actions: ua } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const callIncidencias = async () => {
      if (incidencias.data /* && incidencias.data.length > 0 */) {
        return;
      } else {
        if (ua.hasPermission("camaras.view.incidencias")) {
          await getIncidencias(camara_id, setIncidencias);
        } else {
          navigate("/");
          return;
        }
      }
    };

    callIncidencias();
  }, []);

  return (
    <div>
      {/* <hr /> */}
      <div className="mb-3">
        {ua.hasPermission("camaras.create.incidencias") && (
          <>
            {!incidencias.agregar_incidencia && (
              <Button
                onClick={() =>
                  setIncidencias((prevState) => ({
                    ...prevState,
                    agregar_incidencia: true,
                  }))
                }
              >
                Agregar Incidencia
              </Button>
            )}
            {camara_id && incidencias.agregar_incidencia && (
              <FormAgregarIncidencia
                camara_id={camara_id}
                incidencias={incidencias}
                setIncidencias={setIncidencias}
              />
            )}
          </>
        )}
      </div>

      {incidencias.is_loading ? (
        <MuniSpinner2 />
      ) : incidencias.data && incidencias.data.length > 0 ? (
        <Table data={tableData(incidencias.data)} name="incidencias" />
      ) : (
        <label>No se cargaron incidencias para la cámara</label>
      )}
    </div>
  );
};

export default Incidencias;
